import {
  addObj,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyPage,
  confirmRemind,
} from '@/api/vehiclereviewplanserv'

export default {
  state: {
    state_VehicleReviewPlan_AddObjResult: null,
    state_VehicleReviewPlan_GetPageResult: null,
    state_VehicleReviewPlan_GetDetailResult: null,
    state_VehicleReviewPlan_ModifyObjResult: null,
    state_VehicleReviewPlan_DeleteObjResult: null,
    state_VehicleReviewPlan_GetMyPageResult: null,
    state_VehicleReviewPlan_ConfirmRemindResult: null,
  },
  mutations: {
    SET_VEHICLEREVIEWPLAN_ADDOBJ_RESULT: (state, rst) => {
      state.state_VehicleReviewPlan_AddObjResult = rst;
    },
    SET_VEHICLEREVIEWPLAN_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleReviewPlan_GetPageResult = rst;
    },
    SET_VEHICLEREVIEWPLAN_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleReviewPlan_GetDetailResult = rst;
    },
    SET_VEHICLEREVIEWPLAN_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_VehicleReviewPlan_ModifyObjResult = rst;
    },
    SET_VEHICLEREVIEWPLAN_DELETEOBJ_RESULT: (state, rst) => {
      state.state_VehicleReviewPlan_DeleteObjResult = rst;
    },
    SET_VEHICLEREVIEWPLAN_GETMYPAGE_RESULT: (state, rst) => {
      state.state_VehicleReviewPlan_GetMyPageResult = rst;
    },
    SET_VEHICLEREVIEWPLAN_CONFIRMREMIND_RESULT: (state, rst) => {
      state.state_VehicleReviewPlan_ConfirmRemindResult = rst;
    },
  },
  actions: {
    VehicleReviewPlanServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEREVIEWPLAN_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEREVIEWPLAN_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleReviewPlanServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEREVIEWPLAN_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEREVIEWPLAN_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleReviewPlanServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEREVIEWPLAN_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEREVIEWPLAN_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleReviewPlanServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEREVIEWPLAN_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEREVIEWPLAN_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleReviewPlanServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEREVIEWPLAN_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEREVIEWPLAN_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleReviewPlanServ_GetMyPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEREVIEWPLAN_GETMYPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEREVIEWPLAN_GETMYPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleReviewPlanServ_ConfirmRemind({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        confirmRemind(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEREVIEWPLAN_CONFIRMREMIND_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEREVIEWPLAN_CONFIRMREMIND_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_VehicleReviewPlan_AddObjResult: state => {
      return state.state_VehicleReviewPlan_AddObjResult;
    },
    get_VehicleReviewPlan_GetPageResult: state => {
      return state.state_VehicleReviewPlan_GetPageResult;
    },
    get_VehicleReviewPlan_GetDetailResult: state => {
      return state.state_VehicleReviewPlan_GetDetailResult;
    },
    get_VehicleReviewPlan_ModifyObjResult: state => {
      return state.state_VehicleReviewPlan_ModifyObjResult;
    },
    get_VehicleReviewPlan_DeleteObjResult: state => {
      return state.state_VehicleReviewPlan_DeleteObjResult;
    },
    get_VehicleReviewPlan_GetMyPageResult: state => {
      return state.state_VehicleReviewPlan_GetMyPageResult;
    },
    get_VehicleReviewPlan_ConfirmRemindResult: state => {
      return state.state_VehicleReviewPlan_ConfirmRemindResult;
    },
  }
}